import apiClient from '@/services/axios'

export async function post(documentTemplateId) {
  var response = await apiClient({
    method: 'post',
    url: '/certificates/' + documentTemplateId + '/email',
    responseType: 'blob'
  })

  if (response) {
    return response.data
  }

  throw new Error('Unable to send certifiate email.')
}